<template>
  <div>
    <BasePopup v-model="isContactUpdatePopupOpen" customClass="custom-popup mn-wd640">
      <div class="popup-header">
        <h3 class="title">연락처 등록</h3>
        <button type="button" class="btn-cancel" @click="handleClose"></button>
      </div>
      <div class="popup-body">
        <form>
          <fieldset>
            <legend>연락처 등록 정보 작성 폼</legend>
            <div class="form-box">
              <div class="form-group">
                <HconInput type="text" v-model:model-value="inputRcvrGrpNm" label="연락처 그룹" :hide-label="false" inputClass="md"  placeholder="연락처 그룹을 입력해주세요."/>
              </div>
            </div>
            <div class="form-box mt28">
              <div class="form-group" :class="{'error': isRcvrNmError}">
                <HconInput type="text" pattern="kor_eng" ref="inputRcvrNmRef" v-model:model-value="inputRcvrNm" label="이름" :hide-label="false" inputClass="md" placeholder="이름을 입력해주세요."/>
              </div>
              <p v-if="isRcvrNmError && isRcvrNmErrorType == 'null'" class="helper-text error">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"이름을","입력")}}</p>
              <p v-if="isRcvrNmError && isRcvrNmErrorType == 'blank'" class="helper-text error">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9164,"이름에","공백만 입력할 수")}}</p>
              <p v-if="isRcvrNmError && isRcvrNmErrorType == 'space'" class="helper-text error">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9002,"이름을")}}</p>
              <p v-if="isRcvrNmError && isRcvrNmErrorType == 'type'" class="helper-text error">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9003,"이름은","한글 또는 영문")}}</p>
            </div>
            <div class="form-box mt28">
              <div class="form-group" :class="{'error': isRcvrMblTelnoError}">
                <HconInput type="text" ref="inputRcvrMblTelnoRef" v-model:model-value="inputRcvrMblTelno" label="휴대전화번호" :hide-label="false" inputClass="md" placeholder="휴대전화번호를 입력해주세요."/>
              </div>
              <p v-if="isRcvrMblTelnoError && isRcvrMblTelnoErrorType == 'null'" class="helper-text error">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"휴대전화번호를","입력")}}</p>
              <p v-if="isRcvrMblTelnoError && isRcvrMblTelnoErrorType == 'type'" class="helper-text error">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9008,"휴대전화번호")}}</p>
            </div>
          </fieldset>
          <div class="box-gray inset40 border-gray mt28">
            <div class="box-inner">
              <p class="popup-text ta-c fs15 text-black"><strong class="font-bold text-green">최대 1,000건</strong>까지 대량 등록할 수 있습니다.<br/>양식을 내려받아 작성 후 업로드해 주세요.</p>
              <div class="button-box col2 mt16">
                <button type="button" @click="downloadExcelRequest" class="btn btn-outline">양식 다운로드</button>
                <button type="button" @click="uploadExcelRequest" class="btn btn-outline">엑셀 업로드</button>
                <input ref="fileInputRef" type="file" accept=".xlsx, .xls" style="display: none;" @change="onFileChange" @click="clearFileInput"/>
              </div>
            </div>
          </div>
          <div class="agree-box mt28" :class="{'error': isPrivacyAgreedError}">
            <HconCheckBox type="default" @change="changeCheckedPrivacyAgreed" :checked="false" label="개인정보 수집 및 이용에 동의합니다." name="allCheckBtn" labelClass="font-bold fs18 gap5" :showTextBefore="true" text="[필수]" textClass="font-normal text-red" :hide-label="false"/>
            <p v-if="(isPrivacyAgreedError && isPrivacyAgreedErrorType == 'null')" class="helper-text error pl31">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9111)}}</p>
            <div class="y-auto mx-hg300">
              <div class="box-gray mt18">
                <ul class="dot-list black">
                  <li class="fs15">수집 항목 : 이름, 휴대전화번호</li>
                  <li class="fs15">수집 이용·목적 : 연락처 등록/이용</li>
                  <li class="fs15">개인정보의 보유 및 이용기간 : <strong class="text-green">동의 철회 또는 탈퇴 후 30일</strong><br/>
                    <span class="text-gray02">*Hcon내 연락처 등록에 대해 거부하실 수 있으며, 거부 시 연락처 등록이 불가합니다.</span></li>
                </ul>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="popup-footer jc-c">
        <div class="button-box col2">
          <button type="button" @click="receiveTelnoRegist" class="btn md">동의하고 등록</button>
        </div>
      </div>
    </BasePopup>
  </div>
  <HconReceiveTelnoPopupBulkRegistration :file="sendListfile" v-if="receiveTelnoPopupOpen" @success="handlePopup" @cancel="handlePopup"/>
</template>
<script lang="ts" setup>
import HconInput from '@/components/com/HconComPCInputField.vue';
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import BasePopup from '@/components/com/HconComBasePopup.vue'
import { usePopup } from '@/composables/hconUsePopup'
import { COMMON_CODE, MEMBER_CODE } from '~/constants/hconMessageConstants';
import HconReceiveTelnoPopupBulkRegistration from '~/components/popup/HconReceiveTelnoPopupBulkRegistration.vue';
import { HconCommonRegExp } from '@/constants/hconRegexConstants'

const {showAlert} = usePopup()

// 연락처 등록 팝업
const isContactUpdatePopupOpen = ref(false)

// 팝업 열림
const handleOpen = () => {
  isContactUpdatePopupOpen.value = true
}

onMounted(() => {
  // 팝업 열림
  handleOpen();
})

// 부모컴포넌트에 넘길 값
const emit = defineEmits(['success','cancel']);

// [X] 버튼 클릭 > 팝업 닫힘
const handleClose = () => {
  emit('cancel');
  isContactUpdatePopupOpen.value = false;
}

// [동의하고 등록] 버튼 클릭 > 값 부모창에 전달 및 팝업 닫힘
const closePopup = () => {
  emit('success', 'Y');
  isContactUpdatePopupOpen.value = false;
}

// 연락처 그룹
const inputRcvrGrpNm = ref("")
// 이름
const inputRcvrNm = ref("")
const inputRcvrNmRef = ref<InstanceType<typeof HconInput> | null>(null)
const isRcvrNmError = ref(false)
const isRcvrNmErrorType = ref()
// 휴대전화번호
const inputRcvrMblTelno = ref("")
const inputRcvrMblTelnoRef = ref<InstanceType<typeof HconInput> | null>(null)
const isRcvrMblTelnoError = ref(false)
const isRcvrMblTelnoErrorType = ref()
// 개인정보 수집 및 이용 동의 여부
const checkedPrivacyAgreed = ref("N")
const isPrivacyAgreedError = ref(false)
const isPrivacyAgreedErrorType = ref()

// 연락처 대량 등록 팝업 
const receiveTelnoPopupOpen = ref(false);

// 연락처 등록 엑셀 파일 (연락처 대량 등록 팝업에 넘길 데이터)
const sendListfile = ref<File | null>(null);
const fileInputRef = ref<HTMLInputElement | null>(null);

// 개인정보 수집 및 이용 동의 여부 change 이벤트 
const changeCheckedPrivacyAgreed = (isCheckedPrivacyAgreed : boolean) => {
  checkedPrivacyAgreed.value = isCheckedPrivacyAgreed ? 'Y' :'N'
}

// validate checkFlag
const checkFlag = ref(false);

// 유효성 체크
const validateCheck = () => {

  isRcvrNmError.value = false
  isRcvrNmErrorType.value = ""
  isRcvrMblTelnoError.value = false
  isRcvrMblTelnoErrorType.value = ""
  isPrivacyAgreedError.value = false
  isPrivacyAgreedErrorType.value = ""

  // 이름 Null 체크
  if(HconCommonUtils.isEmpty(inputRcvrNm.value)) {
    // 이름 Focus 적용
    if(inputRcvrNmRef.value) {
      inputRcvrNmRef.value.onInputTextFocus();
    }
    isRcvrNmError.value = true
    isRcvrNmErrorType.value = 'null' 
    return checkFlag.value = false;
  }

  // 이름 공백 체크
  if(inputRcvrNm.value.trim().length == 0) {
    // 이름 Focus 적용
    if(inputRcvrNmRef.value) {
      inputRcvrNmRef.value.onInputTextFocus();
    }
    isRcvrNmError.value = true
    isRcvrNmErrorType.value = 'blank'
    return checkFlag.value = false;
  }

  // 이름 띄어쓰기 체크
  if(inputRcvrNm.value.includes(' '))  {
    // 이름 Focus 적용
    if(inputRcvrNmRef.value) {
      inputRcvrNmRef.value.onInputTextFocus();
    }
    isRcvrNmError.value = true
    isRcvrNmErrorType.value = 'space'
    return checkFlag.value = false;
  }

  // 이름 타입 체크
  if(!HconCommonRegExp.USER_NAME_REGEX.test(inputRcvrNm.value)) {
    // 이름 Focus 적용
    if(inputRcvrNmRef.value) {
      inputRcvrNmRef.value.onInputTextFocus();
    }
    isRcvrNmError.value = true
    isRcvrNmErrorType.value = 'type'
    return checkFlag.value = false;
  }

  isRcvrNmError.value = false
  isRcvrNmErrorType.value = "" 

  // 휴대전화번호 Null 체크
  if(HconCommonUtils.isEmpty(inputRcvrMblTelno.value)) {
    // 휴대전화번호 Focus 적용
    if(inputRcvrMblTelnoRef.value) {
      inputRcvrMblTelnoRef.value.onInputTextFocus();
    }
    isRcvrMblTelnoError.value = true
    isRcvrMblTelnoErrorType.value = 'null' 
    return checkFlag.value = false;
  }

  // 휴대전화번호 타입 체크
  if(!HconCommonRegExp.Mbl_Telno_REGEX_NO_DASH.test(inputRcvrMblTelno.value.replace(/-/g,''))) {
    // 휴대전화번호 Focus 적용
    if(inputRcvrMblTelnoRef.value) {
      inputRcvrMblTelnoRef.value.onInputTextFocus();
    }
    isRcvrMblTelnoError.value = true
    isRcvrMblTelnoErrorType.value = 'type'
    return checkFlag.value = false;
  }

  isRcvrMblTelnoError.value = false
  isRcvrMblTelnoErrorType.value = "" 

  // 개인정보 수집 및 이용동의 여부 Null 체크
  if(checkedPrivacyAgreed.value == 'N') {
    isPrivacyAgreedError.value = true
    isPrivacyAgreedErrorType.value = 'null'  
    return checkFlag.value = false;
  }

  isPrivacyAgreedError.value = false
  isPrivacyAgreedErrorType.value = ""

  return checkFlag.value = true;

}

const fetchBuilder  = useHconFetchBuilder();

// 연락처 등록 API 호출
const receiveTelnoRegist = async () => {
  validateCheck();
  if(checkFlag.value == true) {
    const fetchBuilderResult = 
    await fetchBuilder.post<AjaxResult<boolean>>('/api/v1/mypage/receivePerson/receiveTelno-regist')
    .body({
      rcvrMblTelno: inputRcvrMblTelno.value.replace(/-/g,''),
      rcvrGrpNm: inputRcvrGrpNm.value,
      rcvrNm: inputRcvrNm.value,
      tncYn: checkedPrivacyAgreed.value
    })
    .progressMessage("잠시만 기다려주세요...")
    .preventErrorNotify()
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode == '200') {
        if(result.data == true) {
          showAlert({
            title: '알림', 
            message : HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9099),
            onConfirm: () => {closePopup()}
          })
        }
      }
    })
    .catch((error) => {
      // 응답코드가 200이 아닌경우
      if(error.resultCode != '200') {
        showAlert(error.resultMessage)
      }
    })
  }
}

// 양식 다운로드 버튼 click 이벤트(리소스 파일 다운로드)
const downloadExcelRequest = () => {
  // hcon_fo_api 프로젝트 폴더 내 resources/import-form 하위에 있는 파일 다운로드
  const apiBaseUrl = useHconConfig().api.baseUrl;
  const fileName = 'Hcon_excelSample_receiveTelno.xlsx';
  window.location.href = `${apiBaseUrl}/api/v1/common/download/form/${fileName}`;
}

// 엑셀 업로드 버튼 click 이벤트(윈도우탐색기 호출)
const uploadExcelRequest = () => {
  fileInputRef.value?.click();
}

// file의 HTMLInputElement 요소 값을 비워야 동일 파일 재업로드 가능
const clearFileInput = () => {
  if(fileInputRef.value) {
    fileInputRef.value.value = ''
  }
}

// 파일 선택 이벤트
const onFileChange = (e:Event) => {

  const target = e.target as HTMLInputElement;
  if(!target.files || target.files.length === 0) return;
  
  // 선택한 파일
  const selectedFile = target.files[0];

  // 엑셀 파일 확장자 체크
  const isExcel = selectedFile.name.endsWith('.xlsx') || selectedFile.name.endsWith('.xls');
  if (!isExcel) {
    target.value = '';

    (document.activeElement as HTMLInputElement)?.blur()

    showAlert({ 
      title: '잘못된 파일',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9083)
    });
    
    if(fileInputRef.value) {
      fileInputRef.value.value = ""
    }

    return false
  }
  else {
    sendListfile.value = selectedFile;
    // 연락처 대량 등록 팝업 open
    receiveTelnoPopupOpen.value = true;
  }
}

// 연락처 대량 등록 팝업 
const handlePopup = (value:any) => {
  receiveTelnoPopupOpen.value = false;
  // 정상적으로 연락처 대량 등록 시 연락처 등록 팝업 close
  if(value == 'Y') {
    closePopup()
  }
}

</script>
<style lang="scss">
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>